/**
 * Os textos montados da página do resultado auditado (E153.F3): os rótulos vêm de `pt-BR.resultado`
 * e, para o que a formalização e a conferência das etapas já nomeiam, dos módulos delas. A chave do
 * servidor não vai para a tela: o que não tem texto aqui não aparece.
 */
import type { BadgeProps } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { LiberacaoDaEtapa } from '@/lib/conferencia_das_etapas';
import type { EstadoDaVeracidade } from '@/lib/formalizacaoAvaliacao';
import type {
  ResultadoPublico,
  SituacaoDoArtefato,
  SituacaoDoResultado,
} from '@/lib/resultadoAuditado';

import { preencher } from '../FichaDaLeitura/textos';

export { preencher };

export const t = ptBR.resultadoAuditado;
export const tf = ptBR.formalizacaoAvaliacao;
export const te = ptBR.conferenciaDasEtapas;

export type Variante = NonNullable<BadgeProps['variant']>;

export const VARIANTE_DA_SITUACAO: Readonly<Record<SituacaoDoResultado, Variante>> = {
  aguardando_processamento: 'neutral',
  pendencia_tecnica: 'danger',
  em_conferencia: 'info',
  preparado: 'success',
};

export const VARIANTE_DA_LIBERACAO: Readonly<Record<LiberacaoDaEtapa, Variante>> = {
  aprovado: 'success',
  corrigir: 'warning',
  bloqueado: 'danger',
};

export const VARIANTE_DA_VERACIDADE: Readonly<Record<EstadoDaVeracidade, Variante>> = {
  aprovado: 'success',
  corrigir: 'warning',
  bloqueado: 'danger',
};

export const VARIANTE_DO_PUBLICO: Readonly<Record<ResultadoPublico, Variante>> = {
  atendido: 'success',
  nao_violada: 'success',
  parcial: 'warning',
  pendente: 'warning',
  nao_demonstrado: 'danger',
  nao_se_aplica: 'neutral',
  irregular: 'danger',
};

export const VARIANTE_DO_ARTEFATO: Readonly<Record<SituacaoDoArtefato, Variante>> = {
  vigente: 'success',
  // E170.F2: o anterior da mesma versão, que um mais novo do mesmo tipo substituiu.
  substituido: 'neutral',
  desatualizado: 'warning',
};

const FORMATO = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: 'America/Sao_Paulo',
});

export function dataCurta(iso: string): string {
  return FORMATO.format(new Date(iso));
}

/** O motivo de a saída não estar disponível; a chave sem texto não aparece. */
export function textoDoMotivoDoConsumo(motivo: string | null): string {
  if (motivo === null || !Object.hasOwn(t.motivoDoConsumo, motivo)) return '';
  return t.motivoDoConsumo[motivo as keyof typeof t.motivoDoConsumo];
}

export function simOuNao(valor: boolean): string {
  return valor ? t.compositores.sim : t.compositores.nao;
}
